export default {
    "/": { page: "Welcome", name: 'Call.Me - Secure Private Communication', auth: false },
    "/ios-coming-soon": { page: "ComingSoon", name: 'Call.Me | Coming Soon for iOS', auth: false },
    "/privacy-policy": { page: "PrivacyPolicy", name: 'Call.Me | Privacy Policy', auth: false },
    "/terms": { page: "Terms", name: 'Call.Me | Terms of Service', auth: false },
    "/about": { page: "About", name: 'Call.Me | About', auth: false },
    "/contact": { page: "Contact", name: 'Call.Me | Contact', auth: false },
    "/404": { page: "auth/404", name: '404', auth: false },
}
